module.exports = __webpack_public_path__ + "img/icon-backbeat.9ecc196c.svg";